<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts/month"
    heading-danish="Rangliste - Spontantællinger seneste 30 dage"
    heading-english="Ranking - Total spontaneous recent 30 days"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
